import {
  Action,
  Assessment,
  Control,
  ExplorerOptionsProps,
} from 'store/assessments/types';
import { DueDeterminedBy, FieldRepeatableOrderEnum } from 'types/types';

export const returnDefaultControl = ({
  sectionId,
  questionId,
  fieldInstanceId,
  suggestionId,
}: {
  sectionId: string | null;
  questionId: string | null;
  fieldInstanceId: string | null;
  suggestionId: string | null | undefined;
}): Control => ({
  reference: '',
  description: '',
  why: '',
  where: '',
  categoryId: '0',
  history: [],
  isReview: false,
  photoIds: [],
  id: '',
  complianceSubtypeId: '',
  complianceTypeId: '',
  sectionId,
  questionId,
  fieldInstanceId,
  suggestionId: suggestionId || null,
  // Generic
  previousParents: [{ id: '1', type: 'section' }],
  reviewNote: '',
  reviewStatusId: null,
});

export const returnDefaultAction = ({
  sectionId,
  questionId,
  fieldInstanceId,
  suggestionId,
}: {
  sectionId: string | null;
  questionId: string | null;
  fieldInstanceId: string | null;
  suggestionId: string | null | undefined;
}): Action => ({
  reference: '',
  description: '',
  customReference: '',
  why: '',
  where: '',
  categoryId: '0',
  timescaleId: '0',
  severityId: '0',
  dueDeterminedBy: DueDeterminedBy.timescaleBased,
  dueTypeId: null,
  dueTimescale: null,
  dueDate: null,
  assignedAccountIds: [],
  assignedTeamIds: [],
  photoIds: [],
  quantity: '1',
  cost: '',
  pin: null,
  id: '',
  complianceSubtypeId: '',
  complianceTypeId: '',
  sectionId,
  questionId,
  fieldInstanceId,
  suggestionId: suggestionId || null,
  // Generic
  history: [],
  isReview: false,
  previousParents: [{ id: '1', type: 'section' }],
  reviewNote: '',
  reviewStatusId: null,
});

export const defaultExplorerOptions: ExplorerOptionsProps = {
  findingsNewReviewed: true,
  findingsUnreviewed: true,
  questionsNegative: true,
  questionsPositive: true,
  questionsUnanswered: true,
  findingShowReference: false,
  findingsCollapse: false,
  size: 'normal',
  questionDescriptions: 'full',
  findingDescriptions: 'full',
  findingAdditional: true,
  findingSuggestionDescriptions: 'full',
  findingSuggestionAdditional: false,
  showValidationErrors: false,
};

export const defaultGroupExplorerOptions: Assessment['filterGroups'][string] = {
  checks: {},
  order: FieldRepeatableOrderEnum.default,
  search: '',
  requiredFields: false,
};
